// ./src/components/features/Events/controls/EventFormatField.tsx
//
// "In person / Online / Hybrid" chooser — a segmented control on the shared
// (name, value) form contract. Reused by the Create Event wizard and the event
// details editor so the options + labels stay in one place.

import React from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedField, SegmentedFieldProps } from '@/components/generic';

// Local mirror of the format values (the canonical enum lives in the wizard
// types; kept internal here to avoid a duplicate export).
const FORMAT = { IN_PERSON: 'in_person', ONLINE: 'online', HYBRID: 'hybrid' };

export type EventFormatFieldProps = Omit<SegmentedFieldProps, 'data'>;

export const EventFormatField: React.FC<EventFormatFieldProps> = (props) => {
  const { t } = useTranslation(['events']);
  return (
    <SegmentedField
      data={[
        { label: t('events:format.inPerson', { defaultValue: 'In person' }), value: FORMAT.IN_PERSON },
        { label: t('events:format.online', { defaultValue: 'Online' }), value: FORMAT.ONLINE },
        { label: t('events:format.hybrid', { defaultValue: 'Hybrid' }), value: FORMAT.HYBRID },
      ]}
      {...props}
    />
  );
};
